import React, { useEffect, useRef, useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import BreadScrumb from "../components/BreadScrumb";
import { GetInventory, RequestDevice } from "../apis/Api";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Cart } from "../utils/helper";
import toast from "react-hot-toast";
import { Loader } from "../common/Loader";
import { useAuth } from "../context/UserContext";
import InventoryFaqs from "../common/InventoryFaqs";
const InventoryPage = () => {
  const navigate = useNavigate();
  const { brand_token, model_token, color_token } = useParams();
  const [inventory, setInventory] = useState();
  const [loading, setLoading] = useState(false);
  const [cart, setCart] = useState([]);
  const user = useAuth();
  const [formData, setFormData] = useState({
    brand: "",
    model: "",
    mobile: "",
    issues: "",
  });
  const [error, setError] = useState();
  const [isCartLoaded, setIsCartLoaded] = useState();
  const [totalPrice, setTotalPrice] = useState(0);
  const [token, setToken] = useState();
  const [isChecked, setIsChecked] = useState(false);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const colorName = searchParams.get("color");

  useEffect(() => {
    if (inventory?.brands?.length > 0) {
      setFormData({
        brand: inventory.brands[0].brand_name || "",
        model: inventory?.model[0]?.model_name || "",
        mobile: "",
        issues: "",
      });
    }
  }, [inventory]);
  useEffect(() => {
    const handleBack = () => {
      localStorage.removeItem("Cart");
    };

    const handleUnload = () => {
      localStorage.removeItem("Cart");
    };

    window.addEventListener("popstate", handleBack);
    window.addEventListener("beforeunload", handleUnload);

    return () => {
      window.removeEventListener("popstate", handleBack);
      window.removeEventListener("beforeunload", handleUnload);
    };
  }, []);

  const validateFields = () => {
    for (let key of Object.keys(formData)) {
      const value = formData[key]?.trim();
  
      // Empty field check
      if (!value) {
        toast.error(`Please enter ${key.replace(/_/g, " ")}`);
        return false;
      }
      if (key === "mobile") {
        console.log("Mobile input:", `"${value}"`); 
  
        const phonePattern = /^[6-9]\d{9}$/;
        if (!phonePattern.test(value)) {
          toast.error("Please enter a valid 10-digit mobile number");
          return false;
        }
      }
    }
  
    return true;
  };

  const postRequest = async () => {
    if (!validateFields()) return;
    try {
      setLoading(true);
      setError(null);

      const timeoutPromise = new Promise((_, reject) =>
        setTimeout(() => reject(new Error("Request timed out")), 10000)
      );

      const data = {
        brand: formData.brand,
        model: formData.model,
        mobile: formData.mobile,
        issue: formData.issues,
      };

      const response = await Promise.race([
        RequestDevice(data),
        timeoutPromise,
      ]);

      if (response.status === 200) {
        toast.success("Query successfully submitted");

        setError(null);
        setFormData({
          issues: "",
          mobile: "",
        });
      } else {
        setError(`Request failed with status: ${response.status}`);
      }
    } catch (error) {
      setError("Failed to submit request. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const fetchInventory = async () => {
    try {
      setLoading(true);
      const updatedDate = {
        brand_token,
        model_token,
        // color_token,
        // color_name: colorName,
      };
      const timeoutPromise = new Promise((_, reject) =>
        setTimeout(() => reject(new Error("Request timed out")), 10000)
      );

      const responsePromise = GetInventory(updatedDate);

      const response = await Promise.race([responsePromise, timeoutPromise]);
      if (response) {
        setInventory(response);
      }
    } catch (error) {
      if (error.message === "Request timed out") {
        console.warn("Request timed out. Retrying or handling...");
        // setError("");
      } else {
        console.error("Error getting Inventory data:", error.message);
        setError(error.message || "Error fetching data");
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const initializeData = async () => {
      try {
        await fetchInventory();

        const storedCart = localStorage.getItem("Cart");
        if (storedCart) {
          const cleanedCart = storedCart.replace(/\\/g, "");
          const parsedCart = JSON.parse(cleanedCart);

          setCart(parsedCart);
        }
      } catch (error) {
        console.log("Error initializing data:", error);
      } finally {
        setIsCartLoaded(true);
      }
    };

    initializeData();
  }, []);

  const HandleAddItem = (increment = true, inventory) => {
    const updatedCart = Cart(
      cart,
      increment,
      inventory,
      brand_token,
      model_token,
      colorName
    );
    setCart(updatedCart);
  };

  useEffect(() => {
    if (cart.length > 0) {
      const firstCartItemColor = cart[0].color_name;
      if (firstCartItemColor !== colorName) {
        setCart([]);
        localStorage.removeItem("Cart");
        setTotalPrice(0);
      }
    }
  }, [colorName, cart]);

  const calculateTotalPrice = () => {
    return cart.reduce((accumulator, item) => {
      return accumulator + parseInt(item.payable_price) * item.quantity;
    }, 0);
  };

  useEffect(() => {
    const totalPrice = calculateTotalPrice();
    setTotalPrice(parseInt(totalPrice));
  }, [cart]);

  const formatedPrice = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "INR",
  }).format(parseInt(totalPrice));

  useEffect(() => {
    const updateAsyncStorage = async () => {
      try {
        localStorage.setItem("Cart", JSON.stringify(cart));
      } catch (error) {
        console.error("Error saving cart to AsyncStorage:", error);
      }
    };

    if (isCartLoaded) {
      updateAsyncStorage();
    }
  }, [cart, isCartLoaded]);

  if (loading) {
    return (
      <>
        <Header />
        <div className="container">
          <div className="row">
            <div
              className="col-md-12 d-flex justify-content-center flex-column align-items-center"
              style={{ minHeight: "80vh", backgroundColor: "white" }}
            >
              <Loader />
            </div>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  return (
    <div>
      <Header setToken={setToken} />
      <div id="content" className="no-top no-bottom">
        <BreadScrumb
          title="Inventory"
          Banner="/assets/images/background/3.webp"
        />
        <div className="green-color" style={{ marginTop: "30px" }}></div>
        {inventory?.data && inventory?.data.length > 0 ? (
          <div class="container my-5">
            <div class="row">
              <div class="col-md-8">
                <div class="d-flex align-items-center mb-4">
                  <div class="phone-img-container me-4">
                    <img
                      src={inventory?.phone_url}
                      alt="iPhone 11"
                      class="img-fluid"
                    />
                  </div>
                  <div>
                    <h2 class="mb-1">{inventory?.brands?.brand_name}</h2>
                    <p class="mb-0">
                      Model: <strong>{inventory?.model?.model_name}</strong>
                    </p>
                    {/* <p class="mb-0">
                      Color: <strong>{inventory?.color?.color_name}</strong>
                    </p> */}
                    <p class="mb-0">
                      Color: <strong>Genuine</strong>
                    </p>
                  </div>
                </div>

                <h5 class="fw-bold mb-3">Pick Your Repair Service</h5>

                <div className="row repair-row">
                  {inventory?.data.map((result, index) => (
                    <div className="col-md-4 mb-3" key={index}>
                      <div
                        className="d-flex align-items-start justify-content-between p-2 border rounded"
                        style={{ minHeight: "100px" }}
                      >
                        {/* Icon + Text */}
                        <div className="d-flex">
                          <div className="me-2">
                            <img
                              src={result?.url}
                              alt="Screen"
                              className="img-fluid"
                              style={{
                                width: "35px",
                                height: "35px",
                                objectFit: "contain",
                              }}
                            />
                          </div>
                          <div>
                            <div
                              className="fw-bold text-capitalize text-wrap"
                              style={{ fontSize: "13px", maxWidth: "180px" }}
                            >
                              {result?.product}
                            </div>
                            <div>
                              <span className="fw-bold">
                                ₹{parseInt(result?.payable_price)}
                              </span>
                              <span className="old-price ms-1 text-muted text-decoration-line-through">
                                ₹{parseInt(result?.main_price)}
                              </span>
                            </div>
                          </div>
                        </div>

                        {/* Add/Remove Button */}
                        <div>
                          {cart.find((item) => item.token === result.token) ? (
                            <button
                              className="btn btn-sm btn-outline-danger"
                              style={{
                                height: "35px",
                                width: "80px",
                                fontSize: "12px",
                                borderRadius: "5px",
                              }}
                              onClick={() => HandleAddItem(false, result)}
                            >
                              Remove
                            </button>
                          ) : (
                            <button
                              className="btn btn-sm text-white"
                              style={{
                                height: "35px",
                                width: "80px",
                                fontSize: "12px",
                                borderRadius: "5px",
                                backgroundColor: "#73b734",
                              }}
                              onClick={() => HandleAddItem(true, result)}
                            >
                              Add Item
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}

                  {/* Request A Device Button */}
                  <div className="col-12 text-center mt-3">
                    <span
                      data-bs-toggle="modal"
                      data-bs-target="#myModal"
                      className="findmyphone text-light d-inline-block"
                      style={{
                        fontSize: "14px",
                        backgroundColor: "#73B734",
                        padding: "10px 20px",
                        borderRadius: "5px",
                        cursor: "pointer",
                      }}
                    >
                      Request A Device
                    </span>
                  </div>
                </div>
                <InventoryFaqs />
              </div>

              <div class="col-md-4">
                <div class="card shadow-sm">
                  <div class="card-body">
                    <h5 class="card-title border-bottom pb-3">Price Summary</h5>
                    <div class="d-flex flex-column text-capitalize fw-bold py-3">
                      {cart.length > 0 ? (
                        cart.map((result, idx) => (
                          <div
                            key={result.id}
                            class="d-flex justify-content-between w-100 mb-2"
                          >
                            <div class="d-flex align-items-center gap-2">
                              <span class="badge bg-light text-primary px-2">
                                {idx + 1}
                              </span>
                              <span
                                className="text-wrap"
                                style={{ fontSize: "14px" }}
                              >
                                {result.product}
                              </span>
                            </div>
                            <div class="d-flex gap-2">
                              <span class="text-dark fw-bold">
                                ₹{parseInt(result.payable_price)}
                              </span>
                            </div>
                          </div>
                        ))
                      ) : (
                        <div>No Service Selected</div>
                      )}
                    </div>
                    <div class="d-flex justify-content-between align-items-center fw-bold mb-3">
                      <span>Total Amount</span>
                      <div class="d-flex align-items-center gap-2">
                        <span class="text-dark fs-5">₹{totalPrice}</span>
                      </div>
                    </div>

                    <div class="mb-3">
                      <div class="form-check">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          id="terms"
                          checked={isChecked}
                          onChange={() => setIsChecked(!isChecked)}
                        />
                        <label class="form-check-label" for="terms">
                          I agree to the <a href="#">Terms and Conditions</a>
                        </label>
                      </div>
                    </div>

                    <button
                      {...(!localStorage.getItem("token") && {
                        "data-bs-toggle": "modal",
                        "data-bs-target": "#loginModal",
                      })}
                      className="book-now-btn w-100 d-flex justify-content-between align-items-center"
                      onClick={() => {
                        if (localStorage.getItem("token")) {
                          if (
                            !localStorage.getItem("Cart") ||
                            JSON.parse(localStorage.getItem("Cart")).length ===
                              0
                          ) {
                            toast.error("Please Select Service");
                            return;
                          }
                          if (!isChecked) {
                            toast.error(
                              "Please accept the terms & conditions."
                            );
                            return;
                          }
                          navigate(`/checkout`);
                        }
                      }}
                    >
                      <span>Book Now</span>
                      <span>→</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="text-center py-5">
            <p>No Inventory Found</p>
          </div>
        )}
      </div>
      <Footer />

      <div className="modal fade" id="myModal" tabIndex="-1">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" style={{ color: "#73b734" }}>
                Submit Your Query
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
              ></button>
            </div>

            <div className="modal-body">
              <form>
                <div className="mb-3">
                  <label className="form-label">
                    Mobile Number <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    value={formData.mobile}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        mobile: e.target.value,
                      })
                    }
                    className="form-control border border-success"
                    placeholder="Enter Mobile Number"
                    // required
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">
                    Issues <span className="text-danger">*</span>
                  </label>
                  <textarea
                    className="form-control border border-success"
                    rows="3"
                    value={formData.issues}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        issues: e.target.value,
                      })
                    }
                    placeholder="Describe the issues"
                    required
                  ></textarea>
                </div>
              </form>
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-outline-success"
                data-bs-dismiss="modal"
                style={{ height: "40px", width: "80px" }}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="btn"
                onClick={postRequest}
                style={{
                  backgroundColor: "#73b734",
                  color: "white",
                  height: "40px",
                  width: "80px",
                }}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InventoryPage;
